import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default (title) => {
  const { data: brandingData } = useSelector((state) => state.branding);

  useEffect(() => {
    const favicon = document.getElementById('favicon');
    favicon.href = brandingData.icon;
  }, [brandingData.icon]);

  useEffect(() => {
    document.title = `${brandingData.displayName || 'React App'} - ${title}`;
  }, [brandingData.displayName]);
};
